export default __webpack_public_path__ + "static/media/ex.68185477.png";